/** Capacitor footer visibility sync (see TotalConnectRTC lifecycle). */
export const CAPACITOR_FOOTER_VISIBILITY_EVENT = 'capacitor-footer-visibility-change';

/** Panel height — bottom inset for native shell footer. */
export const CAPACITOR_CONNECT_PANEL_BOTTOM = 'var(--safe-area-inset-bottom)';

/** Footer clearance when Capacitor tab bar is visible (safe-area already in panel bottom). */
export const CAPACITOR_CONNECT_FOOTER_CLEARANCE = '80px';
